import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { AreaModel } from 'src/models/regions/area';
import { API_url } from '../api.setup';
import { request } from 'src/utils/axios.interceptor';

const API_Controller = '/area';

export const AreaService = {
  getAllArea: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as AreaModel[];
    } catch (error) {
      throw error;
    }
  },

  addArea: async (areaToUpdate: AreaModel) => {
    try {
      const reqModel = {
        name: areaToUpdate.name,
        status: areaToUpdate.status,
        pinCode: areaToUpdate.pinCode,
        cityID: areaToUpdate.city.id
      };
      const response = await axios.post(
        `${API_url}${API_Controller}`,
        reqModel
      );
      return response.data as AreaModel;
    } catch (error) {
      enqueueSnackbar(`Area  Added Unsuccessfully`, {
        variant: 'error'
      });
      console.error(error);
      throw error;
    }
  },

  deleteArea: async (areaId) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${areaId}`
      );
      enqueueSnackbar(`Area Deleted Successfully`, {
        variant: 'success'
      });
      return response.data as AreaModel;
    } catch (error) {
      throw error;
    }
  },

  editArea: async (editedData: AreaModel) => {
    try {
      const reqModel = {
        id: editedData.id,
        name: editedData.name,
        status: editedData.status,
        pinCode: editedData.pinCode,
        cityID: editedData.city.id
      };
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        reqModel
      );
      const updatedArea = {
        ...response.data,
        city: editedData.city
      };

      return updatedArea as AreaModel;
    } catch (error) {
      enqueueSnackbar(`Area " ${editedData.name} " Edited Unsuccessfully`, {
        variant: 'error'
      });
      throw error;
    }
  }
};
